import { nullable2undefinable } from 'core/utils/commonUtils';
import { http } from 'core/utils/httpClient';
import type { CreateOrUpdateOrderPaymentRequest } from './dtoModels/order/createOrUpdateOrderPaymentRequest';
import type { OrderPaymentInfoResponse } from './dtoModels/order/orderPaymentInfoResponse';
import type { OrderPaymentInfo } from 'models/order/orderPaymentInfo';

export const mapOrderPayment = (source: OrderPaymentInfoResponse): OrderPaymentInfo => ({
  ...source,
  dateCreate: new Date(source.dateCreate),
  datePayment: new Date(source.datePayment),
  user: nullable2undefinable(source.user),
});

export const mapOrderPayments = (
  source: OrderPaymentInfoResponse[]
): OrderPaymentInfo[] => source.map((ps) => mapOrderPayment(ps));

export async function getOrderPaymentsAsync(
  orderId: number
): Promise<OrderPaymentInfo[]> {
  const { data } = await http.get<OrderPaymentInfoResponse[]>(
    `orders/${orderId}/payments`
  );

  return mapOrderPayments(data);
}

export async function createOrderPaymentAsync(
  orderId: number,
  request: CreateOrUpdateOrderPaymentRequest
): Promise<OrderPaymentInfo> {
  const { data } = await http.post<OrderPaymentInfoResponse>(
    `orders/${orderId}/payments`,
    request
  );
  return mapOrderPayment(data);
}

export async function updateOrderPaymentAsync(
  orderId: number,
  paymentId: number,
  request: CreateOrUpdateOrderPaymentRequest
): Promise<OrderPaymentInfo> {
  const { data } = await http.put<OrderPaymentInfoResponse>(
    `orders/${orderId}/payments/${paymentId}`,
    request
  );
  return mapOrderPayment(data);
}
